import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useFooter } from 'components/Footer/FooterContext';

const Footer = () => {
  const { t } = useTranslation();
  const { openFooterModal, closeFooterModal, modalContent, isFooterModalOpen } = useFooter();

  // Questa funzione gestisce il click sui link del footer
  const handleLinkClick = (event, resource) => {
    console.log('Clicked resource:', resource);
    if (resource) {
      event.preventDefault();
      const title = t(`global.footer.${resource}-title`);
      const text = t(`global.footer.${resource}-text`);
      console.log('Modal content:', { title, text });
      openFooterModal({
        title,
        text
      });
      console.log('Modal should be open');
    }
  };

  // Definisco gli stili dei link
  const linkStyle = {
    cursor: 'pointer',
    color: 'white',
    borderRadius: '0.4rem',
    margin: '0.1rem 0',
    padding: '0.2rem',
    transition: 'all 0.3s',
    '&:hover': {
      opacity: 0.5,
      textDecoration: 'underline',
      backgroundColor: 'rgba(255, 255, 255, 0.2)'
    }
  };

  return (
    <>
      {/* Wrapper per i link del footer */}
      <Box className="custom-flex-terms-cockies">
        <Box className="terms-cockies"
          sx={linkStyle}
          dangerouslySetInnerHTML={{ __html: t('global.footer.terms-link') }}
          onClick={(event) => handleLinkClick(event, 'terms')}
        />
        <Box className="terms-cockies"
          sx={linkStyle}
          dangerouslySetInnerHTML={{ __html: t('global.footer.cookies-link') }}
          onClick={(event) => handleLinkClick(event, 'cookies')}
        />
      </Box>
      {/* Modale per mostrare il contenuto dei link */}
      <Dialog open={isFooterModalOpen} onClose={closeFooterModal}>
        <DialogTitle>{modalContent.title}</DialogTitle>
        <DialogContent>
          <Box dangerouslySetInnerHTML={{ __html: modalContent.text }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeFooterModal} color="primary">{t('global.btn.close')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Footer;